import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import CRMImplementation from './pages/services/CRMImplementation';
import ERPIntegration from './pages/services/ERPIntegration';
import SmartCRM from './pages/services/SmartCRM';
import LeadGeneration from './pages/services/LeadGeneration';
import AIEnablement from './pages/services/AIEnablement';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import PostEditor from './pages/admin/PostEditor';

// ScrollToTop component - scrolls to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Layout component for public pages (with header/footer)
function PublicLayout({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

// Layout component for admin pages (no header/footer)
function AdminLayout({ children }) {
  return <>{children}</>;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes - Outside the max-width wrapper */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/posts/new" element={<PostEditor />} />
          <Route path="/admin/posts/:postId/edit" element={<PostEditor />} />
          
          {/* Public Routes - Inside the max-width wrapper */}
          <Route path="/*" element={
            <div className="site-outer-wrapper">
              <div className="site-inner-wrapper">
                <div className="App">
                  <Routes>
                    <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                    <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
                    <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                    <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
                    <Route path="/blog/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
                    <Route path="/services/crm-implementation" element={<PublicLayout><CRMImplementation /></PublicLayout>} />
                    <Route path="/services/erp-integration" element={<PublicLayout><ERPIntegration /></PublicLayout>} />
                    <Route path="/services/smart-crm" element={<PublicLayout><SmartCRM /></PublicLayout>} />
                    <Route path="/services/lead-generation" element={<PublicLayout><LeadGeneration /></PublicLayout>} />
                    <Route path="/services/ai-enablement" element={<PublicLayout><AIEnablement /></PublicLayout>} />
                  </Routes>
                  <Toaster />
                </div>
              </div>
            </div>
          } />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
